import validate from "D:/mysrc/esoft-web/esoft-official-website/node_modules/nuxt/dist/pages/runtime/validate.js";
import guard_45global from "D:/mysrc/esoft-web/esoft-official-website/src/router-middleware/guard.global.ts";
import manifest_45route_45rule from "D:/mysrc/esoft-web/esoft-official-website/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  guard_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}